import { React, useState } from 'react'
import { Link } from 'react-router-dom'
import App from './app-release.apk'
import Image from './image.svg'
import './styles.scss'

export const DownloadApp = () => {
  const [check, setCheck] = useState(false)
  const change = () => {
    setCheck(!check)
  }
  return (
    <div className='layout' >
      <div className= 'container'>
        <div className = 'right-container p'>
        <h1 className= 'title pt-2'>¡Descarga nuestra app!</h1>
          <object data={Image} className= 'image'> </object>
          <p className= 'text'>Disfruta de RAARR en todas partes </p>
          <p className='text2'> Podrás consultar y organizar tus eventos aquí</p>
          <div className="flex items-center">
            <input onClick={change} id="link-checkbox" type="checkbox" value="" className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"/>
            <label htmlFor="link-checkbox" className="ml-2 text-sm font-medium text-black">&nbsp;Acepto <a href="/terminos-condiciones-app" target= '_blank' className="text-black hover:underline">términos y condiciones</a>.</label>
            <br/> &nbsp;
            <br/>
          </div>
          {check ? (<a href={App} download="RARR.apk" className="btn btn-sm button primary-color fs-sm rounded px-2 me-4"> Download Here  </a>) : (<></>)}
        </div>
        <br/>
      </div>
    </div>
  )
}
